import {
    RaikoBaseCardContainer,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoSectionContainer, RaikoSimpleInputOutlined, showErrorMessage, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {GameRegistrationTypes} from "../../../pages/gameRegistration/GameRegistrationStatusType";
import {GameRegistrationService} from "../../../serverService/gameService/GameRegistrationService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function GamerApprove({registrantId}) {

    const [gamerStatus, setGamerStatus] = useState(GameRegistrationTypes.REJECTED.id);
    const [rejectionReason, setRejectionReason] = useState("")
    const [updateActionButton, setUpdateActionButton] = useState(false)

    const service = new GameRegistrationService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGamerStatusFromServer()
        }
    }, [registrantId]);


    function getGamerStatusFromServer() {
        loading.show()
        service.getGamerStatus(registrantId)
            .then(response => {
                setGamerStatus(response.status)
                setRejectionReason(response.reason ? response.reason : "")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }


    function handleUpdateGamerStatus() {
        if (gamerStatus === GameRegistrationTypes.APPROVED.id) {
            setUpdateActionButton(true)
            service.approveGamerRegistration(registrantId)
                .then(response => {
                    showSuccessMessage("ثبت نام بازیکن با موفقیت تایید شد.")
                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                setUpdateActionButton(false)
            })
        } else if (gamerStatus === GameRegistrationTypes.REJECTED.id) {
            if (rejectionReason !== "") {
                setUpdateActionButton(true)
                service.rejectGamerRegistration(registrantId, rejectionReason)
                    .then(response => {
                        showSuccessMessage("ثبت نام بازیکن رد شد.")
                    }).catch(reason => {
                    showServerErrorMessage(reason)
                }).finally(_ => {
                    setUpdateActionButton(false)
                })
            } else {
                showErrorMessage("لطفا دلیل عدم تایید ثبت نام بازیکن را وارد نمایید.")
            }

        }
    }


    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"پذیرش"}
                hasActionButton
                actionButtonLoadingState={updateActionButton}
                actionButtonOnclick={handleUpdateGamerStatus}
            >
                <RaikoCustomSelect
                    labelText={"پذیرش"}
                    value={gamerStatus}
                    setValue={setGamerStatus}
                    items={[
                        raikoCustomSelectItemGenerator(GameRegistrationTypes.APPROVED.id, GameRegistrationTypes.APPROVED.title),
                        raikoCustomSelectItemGenerator(GameRegistrationTypes.REJECTED.id, GameRegistrationTypes.REJECTED.title),
                    ]}
                />
                {
                    gamerStatus === GameRegistrationTypes.REJECTED.id &&
                    <RaikoSimpleInputOutlined
                        labelText={"دلیل عدم تایید"}
                        value={rejectionReason}
                        setValue={setRejectionReason}
                    />
                }
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}